// extracted by mini-css-extract-plugin
export default {"container":"ticketsuccess_container__nlW6h","title":"ticketsuccess_title__MBm9S","image":"ticketsuccess_image__9KMcw","success":"ticketsuccess_success__iSod7"};